const CONFIRM_LOGOUT_DISABLED_LOCAL_STORAGE_KEY = 'confirmLogout';
const ACTIVE_ROLE_KEY = 'activeRole';

const ASSET_MODAL_STORAGE_KEY = 'ASSET_MODAL';
const FULL_SCREEN_STORAGE_KEY = `${ASSET_MODAL_STORAGE_KEY}:FULLSCREEN`;

export const setDisableConfirmLogout = (isDisabled = false) =>
  globalThis.localStorage.setItem(CONFIRM_LOGOUT_DISABLED_LOCAL_STORAGE_KEY, Boolean(isDisabled));

export const isConfirmLogoutDisabled = () =>
  Boolean(globalThis.localStorage.getItem(CONFIRM_LOGOUT_DISABLED_LOCAL_STORAGE_KEY)) === true;

export const getFullScreenSetting = () => !!globalThis.localStorage.getItem(FULL_SCREEN_STORAGE_KEY);
export const setFullScreenSetting = fullScreen => {
  if (fullScreen) {
    globalThis.localStorage.setItem(FULL_SCREEN_STORAGE_KEY, 'true');
  } else {
    globalThis.localStorage.removeItem(FULL_SCREEN_STORAGE_KEY);
  }
};

export const getActiveRole = () => {
  const activeRoleRaw = globalThis.localStorage.getItem(ACTIVE_ROLE_KEY);
  return activeRoleRaw ? JSON.parse(activeRoleRaw) : null;
};

export const setActiveRole = role => {
  globalThis.localStorage.setItem(ACTIVE_ROLE_KEY, JSON.stringify(role));
};

export const getTimeHistory = () => {
  const timeHistory = globalThis.localStorage.getItem('TIME_HISTORY');
  return timeHistory ? JSON.parse(timeHistory).reverse() : [];
};

export const setTimeHistory = dateRange => {
  const timeHistory = getTimeHistory();
  if (timeHistory.length < 10) {
    timeHistory.push(dateRange);
    globalThis.localStorage.setItem('TIME_HISTORY', JSON.stringify(timeHistory));
  } else {
    timeHistory.pop();
    timeHistory.push(dateRange);
    globalThis.localStorage.setItem('TIME_HISTORY', JSON.stringify(timeHistory));
  }
};

const getRefreshIntervalSettings = () => {
  const refreshIntervalSettings = globalThis.localStorage.getItem('REFRESH_INTERVAL_SETTINGS');
  return refreshIntervalSettings ? JSON.parse(refreshIntervalSettings) : [];
};

export const setRefreshIntervalSetting = ({ key, pause, value, timeUnit }) => {
  const refreshIntervalSettings = getRefreshIntervalSettings();
  const existingRefreshIntervalSettingIndex = refreshIntervalSettings.findIndex(setting => setting.key === key);
  if (existingRefreshIntervalSettingIndex >= 0) {
    refreshIntervalSettings[existingRefreshIntervalSettingIndex] = {
      key: key,
      pause: pause,
      value: value,
      timeUnit: timeUnit,
    };
  } else {
    refreshIntervalSettings.push({ key: key, pause: pause, value: value, timeUnit: timeUnit });
  }
  globalThis.localStorage.setItem('REFRESH_INTERVAL_SETTINGS', JSON.stringify(refreshIntervalSettings));
};

export const getRefreshIntervalSetting = ({ key }) => {
  const refreshIntervalSettings = getRefreshIntervalSettings();
  const refreshIntervalSetting = refreshIntervalSettings.find(setting => setting.key === key);
  return refreshIntervalSetting ? refreshIntervalSetting : null;
};
